import { accessToken } from '@stores/apollo'

interface IProps {
  fileContent: string
  mappings: any[]
}

export default function run({ fileContent, mappings }: IProps): Promise<string> {
  const formData = new FormData()
  formData.append('import[import_type]', 'employee')
  formData.append('import[async]', 'true')
  formData.append('import[file]', fileContent)
  formData.append('access_token', accessToken)

  mappings.forEach((m) => {
    if (m.siq && m.siq !== 'Create Extra Field') {
      formData.append(`import[mapping][${m.csv}]`, m.siq)
    }
  })

  return fetch(`${window.graphqlEndpoint}/imports`, {
    method: 'POST',
    body: formData,
  })
    .then((response) => response.json())
    .then((res: { importId: string } | { error: string }) => {
      if ('error' in res) {
        throw new Error(res.error)
      } else {
        return res.importId
      }
    })
}
